<template>
    <div id="divDatos" class="card-arrange">
        <card-view card-header-title=" Red de Vigilancia Ambiental" card-header-icon-class="fa-solid fa-satellite-dish" data-grid-column-span="2">
            <div class="titulo-card-image">
            <div class="titulo-card-div">
                <label class="titulo-card-label" style="margin-top: 2rem;">{{cntEstTr}} Estaciones con información en tiempo real</label>
            </div>
           <!-- <div class="titulo-card-div">
                <label class="titulo-card-label">{{cntEstAe}} Estaciones de atención de emergencias</label>          
            </div>            
            <div class="titulo-card-div">
                <label class="titulo-card-label">{{cntEstIh}} Estaciones con información Histórica</label> 
            </div>-->
            <div class="titulo-card-div">
                <label class="titulo-card-label">{{cntEstPr}} Estaciones proyectadas</label>    
            </div>
            </div>
            <div>
                <div class="columna2">
                   <label>Estación:</label>
                   <vue-single-select
                        id = "selectEstacion"
                        inputId="selectEstacion_inputId"
                        name = "selectEstacion"
                        placeholder="Seleccionar"                  
                        v-model="WatchEstacion"
                        :options="listaEstacion"
                        option-label="NOM_EST_VIGILA"
                        :max-results="50">
                        <template slot="option" slot-scope="{option, idx}">
                            <div style="display:flex;padding: 2px;font-size: 1rem;"
                                :class="'emoji-happy'">
                                <span style="margin-left: 1rem;">
                                    {{option.NOM_EST_VIGILA}}</span>
                            </div>
                        </template>                        
                    </vue-single-select>
                </div>
            </div>
            <div>
                <div class="columna2">
                   <label>Análisis:</label>
                   <vue-multiselect style="margin-bottom: 5px;"
                        v-model="WatchAnalisis" 
                        :options="listaAnalisis"
                        :multiple="false"
                        group-values="series"
                        group-label="categoria"
                        :group-select="false"
                        track-by="parametro"
                        label="parametro"
                        placeholder="Seleccionar"
                        selectLabel=""
                        deselectLabel=""
                        >
                        <template slot="singleLabel" slot-scope="props">
                            <span class="option__desc">
                                <span class="option__title">{{props.option.parametro}}</span>
                            </span>
                        </template>
                        <template slot="option" slot-scope="props">
                            <!--<img class="option__image" v-if="props.option.$isLabel" :src="imgParametro"> -->
                            <img class="option__image" :src="props.option.img">
                            <span class="option__desc">
                                <span class="option__title" v-if="props.option.$isLabel">{{props.option.$groupLabel}}</span>
                                <span class="option__title" v-else>{{ props.option.parametro }}
                            </span>
                            </span>
                        </template>
                   </vue-multiselect>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <button  type="button"  class="btn btn-primary"  style=" width: 100%; font-weight: bold;" @click="getZoomEstacion" ><i class="esri-icon-rotate-back" style="margin-right: 5px; margin-top: 2px;"></i>Ir a Estación</button>
                </div> 
                <div class="col">
                    <button  type="button"  class="btn btn-primary"  style=" width: 100%; font-weight: bold;" @click="getLoadGrafico" ><i class="esri-icon-time-clock" style="margin-right: 5px; margin-top: 2px;"></i>Actualizar a Fecha Actual</button>
                </div>                
            </div> 
        </card-view>
       <card-view v-if="graficosCargados" card-header-title=" Resultados" card-header-icon-class="fa-solid fa-chart-area" data-grid-column-span="2" class="">
                <vue-friendly-iframe :src="RutaUrl" className="clsIframe"></vue-friendly-iframe>
        </card-view> 
    </div>
</template>

<script>
    import {xmlListToJson, getWebServiceSoap, xml2json} from "@/helpers/xmlhelper";
    import VueSingleSelect from "vue-single-select";
    import VueMultiselect  from "vue-multiselect";
    import CardView from "./CardView";
    import {getFeatures} from "../utils/arcgis_utilities";
    import {arcgisConfig} from "../config";

    import {Vue} from 'vue-property-decorator';
    import axios from "axios";
    import VueFriendlyIframe from 'vue-friendly-iframe';
    //--Registramos el componente HighChart
    Vue.use(VueFriendlyIframe)

    export default {
        name: "VistaVigilanciaAmbiental",
        components: {CardView, VueSingleSelect, VueMultiselect},
        props:{
            WatchCodigo: String,
        },
        data(){
            return {
                listaEstacion: [],
                listaAnalisis: [], 
                WatchEstacion: null,
                WatchAnalisis: null,
                NombreEstacion:'',
                CodigoEstacion:'',
                CodigoGrafico :'',
                RutaUrl:'',
                cntEstTr:0,
                cntEstAe:0,
                cntEstPr:0,
                cntEstIh:0,
                graficosCargados: false,
                imgParametro:'../img/parameter.png'
            }
        },
        async created(){
            //--Parametro de Estación
            this.NombreEstacion = this.$globalVar.PUBLIC_EST_DEFAULT          
            //--Cargamos las Listas Deplegables
            this.LoadEstaciones();
        },
        watch: {
            WatchCodigo(nuevoValor, antiguo){
                if (nuevoValor){
                    this.WatchEstacion = this.listaEstacion.find( s => s.COD_EST_VIGILA === nuevoValor);
                }    
            },
            WatchEstacion(nuevoValor, antiguo){
                if (nuevoValor){
                    this.CodigoEstacion = nuevoValor.ID_EST_VIGILA;                    
                    this.getSearchTask(nuevoValor.ID_EST_VIGILA)
                    this.loadAnalisis(this.CodigoEstacion);
                }
            },
            WatchAnalisis(nuevoValor, antiguo){
                if (nuevoValor){
                    this.CodigoGrafico = nuevoValor.grafico;
                    this.loadGrafico(this.CodigoEstacion,this.CodigoGrafico);
                }
            },                                                                                          
        },
        mounted() {
        },
        methods:{           
            async LoadEstaciones(){
                //--Cargamos los valores de los servicios GIS
                console.log('aca');
                const ID_SERVICIO_RESUMEN = '1';
                let urlConfig = arcgisConfig.srv_consulta.find(s => s.id === ID_SERVICIO_RESUMEN);
                let serviceUrl = urlConfig.url;
                let resultado = await getFeatures({serviceUrl, 
                                                    outFields: ['*'], 
                                                    returnDistinctValues: false,
                                                    returnGeometry:false,
                                                    orderByFields : ['COD_IND ASC']});
                resultado.features.map(f => {
                    switch (f.attributes['COD_IND']) {
                        case 'CODIN001':
                            this.cntEstTr = f.attributes['CANTIDAD'];
                            break;
                        case 'CODIN002':
                            this.cntEstAe = f.attributes['CANTIDAD'];
                            break;                   
                        case"CODIN003":
                            this.cntEstPr = f.attributes['CANTIDAD'];
                            break;
                        default:
                            this.cntEstIh = f.attributes['CANTIDAD'];
                            break;
                    }
                });
                

                axios
                    .get('https://pifa.oefa.gob.pe/node/service/vigmon/api/datos/vig_estaciones')
                    .then(response => {
                        console.log(response)
                        this.listaEstacion = response.data.data
                        //---Seleccionamos el registro
                        console.log('ERR:' + this.listaEstacion); 
  console.log(this.NombreEstacion) 
                        if (this.NombreEstacion !=''){
                            this.WatchEstacion = this.listaEstacion.find( s => s.NOM_EST_VIGILA === this.NombreEstacion);
                        }
                     })
                    .catch(error => {
                        console.log(error)
                        //this.errored = true
                    })
                    .finally(() => this.loading = false)
            },
            async loadAnalisis(codigo){
                axios
                    .get('https://pifa.oefa.gob.pe/node/service/vigmon/api/datos/vig_lista_graficos?id_estacion='+codigo)
                    .then(response => {
                        let Analisis = {categoria:'',
                                        registros:[]}

                        let registros = [];                
                        response.data.data.forEach(f => {
                            let itemGrafico = registros.find(s => s.categoria === f.NOM_GRUPO_GRAFICO);
                            if (!itemGrafico){
                                registros.push({categoria:f.NOM_GRUPO_GRAFICO, series:[]});
                                itemGrafico = registros.find(s => s.categoria === f.NOM_GRUPO_GRAFICO);
                            }
                            itemGrafico.series.push({parametro:f.DESC_GRAFICO, componente:f.NOM_COMPONENTE, grafico:f.ID_GRAFICO, img:'../img/parameter.png'});
                        });
                        this.listaAnalisis = registros;
                        //console.log(this.listaAnalisis)
                        //---Seleccionamos el registro
                        if (registros[0].series[0] !=''){
                            this.WatchAnalisis = registros[0].series[0];
                            //this.loadGrafico(codigo, registros[0].series[0].grafico);
                            //console.log(this.WatchAnalisis)            
                        }
                     })
                    .catch(error => {
                        console.log(error)
                        //this.errored = true
                    })
                    .finally(() => this.loading = false)            
            },
            async loadGrafico(codigo,grafico){
                axios
                    .get('https://pifa.oefa.gob.pe/node/service/vigmon/api/datos/vig_lista_graficos?id_estacion='+codigo)
                    .then(response => {
                        let registros = response.data.data;
                        let itemGrafico = registros.find(s => s.ID_GRAFICO === grafico);
                        if (itemGrafico){
                            this.RutaUrl = itemGrafico.URL;
                            this.graficosCargados = true;
                        }
                     })
                    .catch(error => {
                        console.log(error)
                        //this.errored = true
                    })
                    .finally(() => this.loading = false)                  
            },
            getZoomEstacion(){
                if (this.CodigoEstacion){
                    this.getSearchTask(this.CodigoEstacion);
                    this.loadAnalisis(this.CodigoEstacion);
                }
            },
            getLoadGrafico(){
                if (this.CodigoEstacion || this.CodigoGrafico){
                    this.loadGrafico(this.CodigoEstacion,this.CodigoGrafico);
                }
            },
            getSearchTask(codigo){
                //--Realizamos el Filtro
                let oQueryTask  =  arcgisConfig.queryTasks.find( s => s.id === 1);
                let oQueryWhere =  "COD_ESTACION = '" + codigo + "'";
                let registro = {url: oQueryTask.url + oQueryTask.index,
                                rel: false,
                                fld: oQueryTask.fields,
                                where: oQueryWhere};
                //--Invocamos a la función que se encuentra en el Padre App
                this.$emit('EventZoomElementoEnMapa', registro);
            },

            async setGrabarTask(){
                //--Procedemos a Grabar los datos de la Dirección
            },
            setLimpiarTask(){
            },
            changeTab(tabId){
                this.currentTab = tabId;
                //this.mapFullSize = false;
                //this.boolCloseMenu = tabId+1;
            }

        }
    }

</script>


<style scoped>
</style>